<template>
  <div class="header-popover-wrapper">
    <el-popover
      :visible="visible"
      :virtual-ref="virtualRef"
      virtual-triggering
      width="250">
      <slot />
    </el-popover>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    visible?: boolean
    virtualRef?: any
  }>(),
  {
    visible: false
  }
)
</script>

<style lang="sass" scoped>
.header-popover-wrapper
  :deep(.el-popover)
    color: #c39143
    margin-top: 25px
    padding: 0
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2)
    border-radius: 10px
  :deep(hr)
    width: 100%
    height: 2px
    background-color: #dddddd
    display: block
    border: 0
</style>
